export default __webpack_public_path__ + "static/media/imgLoja02.21983df2.png";